module.exports = __webpack_public_path__ + "static/media/Person7.6b7007c4.png";